export type ResolvedFacet = {
  label: string;
  availableFilters: Filter[];
  currentFilters: Filter[];
};

export type ResolvedFacets<A extends string> = Record<A, ResolvedFacet>;

export type Filter = { label: string; value: string };

export const resolveFacet = <Facet>(props: {
  label: string;
  facets?: Facet[];
  facetToFilter: (facet: Facet) => Filter;
  urlState?: string[];
}): ResolvedFacet => {
  const filters = props.facets?.map(props.facetToFilter);

  return {
    availableFilters: filters || [],
    currentFilters: filters?.filter((filter) => props.urlState?.includes(filter.value)) || [],
    label: props.label,
  };
};
